// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Bd4Hr","label":"styles_label__2wLwP"};